<script>
import Modal from '@/components/atoms/Modal'
import { Address } from '@/api'
import InputLine from '@/components/atoms/inputlib/components/InputLine'
import InputTextarea from '@/components/atoms/inputlib/components/InputTextarea'
import ButtonLoader from '@/components/atoms/ButtonLoader'
import { mapGetters } from 'vuex'
import InputPhone from '@/components/atoms/inputlib/components/InputPhone'
import FormValidation from '@/components/atoms/FormValidation'
import cloneDeep from 'lodash.clonedeep'
import { EventBus } from '@/modules/plugins/modules/event'

export default {
    name: 'ModalCanteenAddress',
    components: {
        FormValidation,
        InputPhone,
        ButtonLoader,
        InputTextarea,
        InputLine,
        Modal,
    },
    data() {
        return {
            address: new Address(),
            model: {},
            value: {},
            loading: false,
            emit: false,
            isValid: true,
            phone: true,
        }
    },
    computed: {
        ...mapGetters({
            canteensList: 'canteen/residentialList',
            activeCanteen: 'active/canteen',
        }),
    },
    mounted() {
        EventBus.$on('openCanteenAddressModal', this.open)
    },
    beforeDestroy() {
        EventBus.$off('openCanteenAddressModal', this.open)
    },
    methods: {
        async open(emit = true) {
            if (!this.$addresses?.total) await this.$addresses.fetch()
            const model = cloneDeep(this.activeCanteen)
            this.emit = emit
            this.model = cloneDeep(model)
            delete model.address.id
            model.address.comment = ''
            this.value = cloneDeep(model.address)
            this.$set(this.value, 'phone', this.$user.model.phone)
            this.$refs.ModalCanteenAddress.openModal()
        },
        close() {
            this.$refs.ModalCanteenAddress.closeModal()
            this.model = {}
            this.value = {}
            this.address.reset()
        },
        submit() {
            this.$refs.form.formSubmit()
        },
        setValidity(value) {
            this.isValid = value
        },
        async save() {
            this.loading = true
            this.address = new Address(this.value)
            await this.address.save()
            await this.$addresses.fetch()
            await this.$store.dispatch('canteen/getResidentialList', true)
            await this.$store.dispatch(
                'active/setCanteen',
                this.canteensList.find((canteen) => {
                    return canteen.id === this.activeCanteen.id
                })
            )
            this.$cart.address = this.activeCanteen.address
            this.$user.getExpenseRules()
            await this.$cart.calculate()
            if (this.emit) this.$emit('saved')
            this.close()
            this.emit = false
            this.loading = false
        },
    },
}
</script>

<template lang="pug">
modal(ref="ModalCanteenAddress")
    template(v-slot:header)
        .modal-header-text {{$t(`canteen.no_address.${emit ? 'title' : 'save'}`)}}
    template(v-slot:body)
        p.h3 {{$t('canteen.no_address.text', {name: model.name})}}
        input-line(:value="value.full_address" disabled readonly) {{$t('details.full_address')}}
        input-line(:value="value.sub_address" disabled readonly) {{$t('details.sub_address')}}
        form-validation(@submit="save" @valid="setValidity" instant-save ref="form")
            input-phone(v-model="value.phone" type="phone" live required) {{$t('labels.phone')}}
            input-textarea(v-model="value.comment" :max="255" live :placeholder="$t('details.placeholder.comment')") {{$t('details.comment')}}
            input-line(
                v-model="value.name"
                :max="255"
                :placeholder="$t('details.placeholder.name')"
                live
                required)
                | {{$t('details.name')}}

    template(v-slot:footer)
        button-loader.btn.btn-primary(@click="submit" :disabled="!isValid" :loading="loading" inline) {{$t('base.save')}}
        button.btn.btn-secondary(@click="close") {{$t('base.cancel')}}
</template>
